import React from 'react';
import Styles from './styles.module.scss';
import { Button } from '@shopify/polaris';

const SupportCardWidget = props => {
  return (
    <div className={`${Styles['container']} d-flex align-items-center flex-column p-25`}>
      <div className={Styles['image-container']}>
        <img src="https://cdn.shopify.com/s/files/applications/7c6742f845a34afe657bd051b0dd037a_200x200.png?1494505017"></img>
      </div>
      <div className={Styles['support-text']}>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
      </div>
      <div className={Styles['btn-container']}>
        <Button
          onClick={props.toggleFaq}
          fullWidth={true}
          primary>
              Visit our help center
        </Button>
      </div>
    </div>
  );
};


export default SupportCardWidget;